<template>
   <v-col  class="col-md-4 col-4">
    <v-card>
      <v-img  :src="src"  class="grey lighten-2">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-card-title primary-title>
        <v-row>
          <v-col cols="6">{{ title }}</v-col>
          <v-col cols="6" class="text-right">
            <v-btn icon color="red" class="btn-card">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: Number,
    src: String,
    id: Number
  },
  data() {
    return {};
  }
};
</script>
<style type="text/css">
.btn-card.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #ff000000 !important;
    color: #fff;
}
</style>